import { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

type AnimatedStatProps = {
  value: number;
  label: string;
  prefix?: string;
  suffix?: string;
  className?: string;
  valueClassName?: string;
  labelClassName?: string;
  duration?: number;
};

const AnimatedStat = ({
  value,
  label,
  prefix = '',
  suffix = '',
  className = '',
  valueClassName = '',
  labelClassName = '',
  duration = 2600,
}: AnimatedStatProps) => {
  const prefersReducedMotion = useReducedMotion();
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    if (prefersReducedMotion) {
      setDisplayValue(value);
      return;
    }

    const startTime = performance.now();

    const frame = (now: number) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      setDisplayValue(Math.round(value * easedProgress));

      if (progress < 1) {
        requestAnimationFrame(frame);
      }
    };

    const animationFrame = requestAnimationFrame(frame);

    return () => cancelAnimationFrame(animationFrame);
  }, [duration, prefersReducedMotion, value]);

  return (
    <div className={className}>
      <div className={valueClassName} aria-label={`${prefix}${value}${suffix} ${label}`}>
        {prefix}
        {displayValue}
        {suffix}
      </div>
      <div className={labelClassName}>{label}</div>
    </div>
  );
};

export default AnimatedStat;
